import React from "react";
import type { KgPresentationIconProps } from "./KgPresentationIcon.types";

/** Presentation / slide icon for artifact panel header (Figma `presentation`, 14px). */
export const KgPresentationIcon: React.FC<KgPresentationIconProps> = ({
  size = 14,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M1.17 1.75H12.84"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M1.75 2.67V8.67C1.75 9.1 2.1 9.43 2.53 9.43H11.47C11.9 9.43 12.25 9.1 12.25 8.67V2.67C12.25 2.24 11.9 1.91 11.47 1.91H2.53C2.1 1.91 1.75 2.24 1.75 2.67Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M4.67 11.33H9.33"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M7 9.33V11.33"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default KgPresentationIcon;
